export const pillBadge: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.2rem 0.65rem',
  fontSize: '0.7rem',
  fontWeight: 600,
  letterSpacing: '0.02em',
  borderRadius: '999px',
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
};
